"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = void 0;
function flatten(list, prop) {
    return list.reduce((flattened, listItem) => flattened.concat(prop(listItem)), []);
}
exports.flatten = flatten;
